/* ════════════ PORTRAIT PIXELATION ════════════
   The same filter the homepage avatar gets in main.ts: sample the
   image down to a coarse grid with smoothing off, then blow it back
   up so every cell lands as a hard square. Block density matches the
   avatar (a 180px canvas sampled at 56 cells ≈ 3.2px per block). */

const BLOCK = 180 / 56;

function pixelate(img: HTMLImageElement) {
  const w = img.width || img.naturalWidth;
  if (!img.naturalWidth || !w) return;

  const nw = Math.max(8, Math.round(w / BLOCK));
  const nh = Math.max(8, Math.round((nw * img.naturalHeight) / img.naturalWidth));

  const tmp = document.createElement("canvas");
  tmp.width = nw;
  tmp.height = nh;
  const tctx = tmp.getContext("2d")!;
  tctx.imageSmoothingEnabled = false;
  tctx.drawImage(img, 0, 0, nw, nh);

  const out = document.createElement("canvas");
  out.width = img.naturalWidth;
  out.height = img.naturalHeight;
  const octx = out.getContext("2d")!;
  octx.imageSmoothingEnabled = false;
  octx.drawImage(tmp, 0, 0, nw, nh, 0, 0, out.width, out.height);

  img.src = out.toDataURL("image/png");
}

export function pixelatePortraits(selector = "img.portrait") {
  document.querySelectorAll<HTMLImageElement>(selector).forEach((img) => {
    if (img.complete && img.naturalWidth) pixelate(img);
    else img.addEventListener("load", () => pixelate(img), { once: true });
  });
}
